module.exports = __webpack_public_path__ + "static/img/wlp1360.82505c1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2025/wlp1360.jpg
// module id = NPow
// module chunks = 0